const checkIsNumber = (value) => {
  if (value === null || value === undefined || isNaN(value) || typeof value !== 'number') {
    throw new TypeError('value must be a number');
  }
}

/**
 * @description 数字运算
 * @param num1 数字1
 * @param num2 数字2
 * @param operator 运行类型 1-加法 2-减法 3-乘法 4-除法
 * @returns {number}
 */
function numProcess(num1, num2, operator) {
  checkIsNumber(num1);
  checkIsNumber(num2);
  if (![1, 2, 3, 4].includes(operator)) {
    throw new Error('operator must be a number');
  }
  let baseNum1, baseNum2, resultNum;
  try {
    baseNum1 = num1.toString().split(".")[1].length;
  } catch (e) {
    baseNum1 = 0;
  }
  try {
    baseNum2 = num2.toString().split(".")[1].length;
  } catch (e) {
    baseNum2 = 0;
  }
  let maxBaseNum = Math.max(baseNum1, baseNum2);
  let tempNum1 = num1.toString().replace(".", "") + "".padEnd(maxBaseNum - baseNum1, 0);
  let tempNum2 = num2.toString().replace(".", "") + "".padEnd(maxBaseNum - baseNum2, 0);
  tempNum1 = parseInt(tempNum1);
  tempNum2 = parseInt(tempNum2);
  switch (operator) {
    case 1:
      resultNum = tempNum1 + tempNum2;
      break;
    case 2:
      resultNum = tempNum1 - tempNum2;
      break;
    case 3:
      resultNum = tempNum1 * tempNum2;
      maxBaseNum = maxBaseNum + maxBaseNum;
      break;
    case 4:
      resultNum = tempNum1 / tempNum2;
      break;
  }
  if (maxBaseNum > 0 && operator !== 4) {
    resultNum = resultNum.toString();
    const numSlicePosition = resultNum.length - maxBaseNum;
    resultNum = resultNum.slice(0, numSlicePosition) + "." + resultNum.slice(numSlicePosition);
    resultNum = parseFloat(resultNum);
  }
  return resultNum;
}

export default {
  /**
   * @description 保留指定位数小数点
   * @returns {String} 格式化的字符串数字
   * @param n - 要保留的小数位数（可选）默认为0
   */
  zzwToFixed: function (n = 0) {
    if (n > 20 || n < 0) {  //精度允许0-20
      throw new RangeError('toFixed() digits argument must be between 0 and 20');
    }
    const number = this;
    if (isNaN(number) || number >= Math.pow(10, 21)) {
      return number.toString();
    }
    if (typeof (n) == 'undefined' || n == 0) {
      return (Math.round(number)).toString();
    }

    //判断是否为负数
    const isMinus = number <= 0;
    let result = number.toString();
    const arr = result.split('.');

    // 整数的情况
    if (arr.length < 2) {
      result += '.';
      for (let i = 0; i < n; i += 1) {
        result += '0';
      }
      return result;
    }

    const integer = arr[0];
    const decimal = arr[1];
    //小数位数和精确位数相等时
    if (decimal.length === n) {
      return result;
    }
    //小数位数小于精确位数时
    if (decimal.length < n) {
      for (let i = 0; i < n - decimal.length; i += 1) {
        result += '0';
      }
      return result;
    }
    result = integer + '.' + decimal.substr(0, n);
    const last = decimal.substr(n, 1);

    // 如果需要进，放大转换为整数再处理，避免浮点数精度的损失
    if (parseInt(last, 10) >= 5) {
      const x = Math.pow(10, n); //放大系数
      // 对于过精度位的下一位值大于5时，正数+1 负数-1.
      // 正数例如1.057 转化为两位精度的小数是 1.06。
      // 负数例如-1.057 转化为两位精度的小数是 -1.06。
      result = (Math.round((parseFloat(result) * x)) + (isMinus ? -1 : 1)) / x;
      //为避免除以系数后小数部分0缺失，再调用一次方法。
      //如1.299，保留两位小数，（1.29*100 + 1）/100=1.3，则需要再补一次零->1.30
      result = result.toFixed(n);
    }
    return result;
  },
  /**
   * @description 加法
   * @param n - 要相加的数字
   * @returns {Number} 运算后的数字
   */
  zzwAdd: function (n) {
    return numProcess(this, n, 1);
  },
  /**
   * @description 减法
   * @param n - 要相减的数字
   * @returns {Number} 运算后的数字
   */
  zzwSub: function (n) {
    return numProcess(this, n, 2);
  },
  /**
   * @description 乘法
   * @param n - 要相乘的数字
   * @returns {Number} 运算后的数字
   */
  zzwMul: function (n) {
    return numProcess(this, n, 3);
  },
  /**
   * @description 除法
   * @param n - 要相除的数字
   * @returns {Number} 运算后的数字
   */
  zzwDiv: function (n) {
    return numProcess(this, n, 4);
  },
  /**
   * @description 金额转大写
   */
  zzwConvertCurrency() {
    let money = this;
    money = money.toString();
    //汉字的数字
    const cnNums = ['零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖'];
    //基本单位
    const cnIntRadice = ['', '拾', '佰', '仟'];
    //对应整数部分扩展单位
    const cnIntUnits = ['', '万', '亿', '兆'];
    //对应小数部分单位
    const cnDecUnits = ['角', '分', '毫', '厘'];
    //整数金额时后面跟的字符
    const cnInteger = '整';
    //整型完以后的单位
    const cnIntLast = '元';
    //最大处理的数字
    const maxNum = 999999999999999.9999;
    //金额整数部分
    let integerNum;
    //金额小数部分
    let decimalNum;
    //输出的中文金额字符串
    let chineseStr = '';
    //分离金额后用的数组，预定义
    let parts;
    // 传入的参数为空情况
    if (money === '') {
      return '';
    }
    money = parseFloat(money);
    if (money >= maxNum) {
      return '';
    }
    // 传入的参数为0情况
    if (money === 0) {
      chineseStr = cnNums[0] + cnIntLast + cnInteger;
      return chineseStr;
    }
    // 转为字符串
    money = money.toString();
    // indexOf 检测某字符在字符串中首次出现的位置 返回索引值（从0 开始） -1 代表无
    if (money.indexOf('.') === -1) {
      integerNum = money;
      decimalNum = '';
    } else {
      parts = money.split('.');
      integerNum = parts[0];
      decimalNum = parts[1].substr(0, 4);
    }
    //转换整数部分
    if (parseInt(integerNum, 10) > 0) {
      let zeroCount = 0;
      let IntLen = integerNum.length;
      for (let i = 0; i < IntLen; i++) {
        let n = integerNum.substr(i, 1);
        let p = IntLen - i - 1;
        let q = p / 4;
        let m = p % 4;
        if (n === '0') {
          zeroCount++;
        } else {
          if (zeroCount > 0) {
            chineseStr += cnNums[0];
          }
          zeroCount = 0;
          chineseStr += cnNums[parseInt(n)] + cnIntRadice[m];
        }
        if (m === 0 && zeroCount < 4) {
          chineseStr += cnIntUnits[q];
        }
      }
      // 最后+ 元
      chineseStr += cnIntLast;
    }
    // 转换小数部分
    if (decimalNum !== '') {
      let decLen = decimalNum.length;
      for (let i = 0; i < decLen; i++) {
        let n = decimalNum.substr(i, 1);
        if (n !== '0') {
          chineseStr += cnNums[Number(n)] + cnDecUnits[i];
        }
      }
    }
    if (chineseStr === '') {
      chineseStr += cnNums[0] + cnIntLast + cnInteger;
    } else if (decimalNum === '') {
      chineseStr += cnInteger;
    }
    return chineseStr
  }
}



// WEBPACK FOOTER //
// ./src/utils/extensions/Number.js